import ServiceCall from './ServiceCall'
export default ServiceCall
